export default "__VITE_ASSET__DWIBcvaz__"